import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnnouncementsFacade } from '@intrack/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardComponent {
  constructor(private announcementsFacade: AnnouncementsFacade) {
    this.announcementsFacade.loadAnnouncement();
  }
}
